// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{
  --logoWidth:2.5rem;
  --logoHeight:2.5rem;
}

.logo{
  display:block;
  width:var(--logoWidth);
  height:var(--logoHeight);
  font-size:0;
  background-repeat:no-repeat;
  background-position:0 0;
  background-size:var(--logoWidth) 100%;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
